<template>
  <div class="ui small modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="key icon"></i>
      {{ $t("jwt access") }}
    </div>
    <div class="scrolling content">
      <div class="ui two item tabular menu" ref="tabs">
        <a class="active item" data-tab="general"
          ><i class="info icon"></i>{{ $t("general") }}</a
        >
        <a class="item" data-tab="tokens"
          ><i class="list icon"></i>{{ $t("tokens") }}</a
        >
      </div>
      <div class="ui bottom attached active tab segment" data-tab="general">
        <div class="ui form" ref="form">
          <div class="fields">
            <div class="eight wide field">
              <label for="">{{ $t("username") }}</label>
              <input type="text" name="username" v-model="username" />
            </div>
            <div class="eight wide field">
              <label for="">{{ $t("status") }}</label>
              <div class="ui toggle checkbox">
                <input type="checkbox" name="is_active" v-model="is_active" />
                <label>{{ $t("is active") }}</label>
              </div>
            </div>
          </div>
          <div class="field">
            <label for="">{{ $t("access key") }}</label>
            <input type="text" name="key" v-model="key" />
          </div>
          <div class="ui error message"></div>
        </div>
      </div>
      <div class="ui bottom attached tab segment" data-tab="tokens">
        <table
          class="ui blue very compact celled striped selectable table"
          ref="table"
          style="width:100%"
        >
          <thead>
            <tr>
              <th>{{ $t("create date") }}</th>
              <th>{{ $t("token") }}</th>
              <th>{{ $t("validity time") }}</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
    </div>
    <div class="actions">
      <div class="ui left floated red icon labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div class="ui left floated orange icon labeled button" @click="remove">
        <i class="trash icon"></i>
        {{ $t("remove") }}
      </div>
      <div class="ui blue icon labeled button" @click="save">
        <i class="check icon"></i>
        {{ $t("ok") }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  local_api,
  error_toast,
  enterprise_setup,
  init_ajax_data_datables,
} from "@/utils";
import filters from "@/filters";

export default {
  name: "JwtAccessModalIndex",
  filters: filters,
  components: {},
  props: {},
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      uuid: "",
      username: "",
      key: "",
      is_active: true,
    };
  },
  methods: {
    show_modal(uuid) {
      let vm = this;

      /**
       * get access
       */
      if (uuid) {
        vm.uuid = uuid;
        vm.init_table();

        local_api(vm, "post", "/api_manager/jwt/do-get", {
          u: uuid,
        })
          .then((r) => {
            if (r) {
              if (r.key) vm.key = r.key;
              if (r.username) vm.username = r.username;
              if (r.status_code) vm.is_active = r.status_code == "A";
            }
          })
          .catch((err) => {
            error_toast(err);
          });
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            setTimeout(() => {
              window
                .jQuery(vm.$refs.tabs)
                .find(".item")
                .tab();
            }, 1000);
          },
          onHide() {
            vm.uuid = "";
            vm.key = "";
            vm.username = "";
            vm.is_active = true;
            vm.form.form("reset");
          },
        })
        .modal("show");

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          username: ["empty"],
          key: ["empty"],
        },
      });
    },
    save() {
      let vm = this;
      let isValid = vm.form.form("validate form");
      if (isValid) {
        local_api(vm, "post", "/api_manager/jwt/do-save", {
          i: vm.uuid,
          n: vm.username,
          k: vm.key,
          s: vm.is_active,
        })
          .then(() => {
            window.jQuery(vm.$refs.modal).modal("hide");
            vm.$emit("saved");
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
    remove() {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove jwt access?"),
        function() {
          local_api(vm, "post", "/api_manager/jwt/do-remove", {
            u: vm.uuid,
          })
            .then(() => {
              vm.$emit("deleted");
              window.jQuery(vm.$refs.modal).modal("hide");
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    init_table() {
      let vm = this;
      if (vm.uuid) {
        let columns = [
          {
            data: function(row) {
              return filters.formatDate(
                row.create_date,
                vm.enterprise_setup.detailed_date_format,
              );
            },
          },
          {
            data: function(row) {
              return filters.truncate(row.token, 35);
            },
          },
          {
            data: function(row) {
              return row.validity_time;
            },
          },
        ];
        let onSelect = (data) => {
          vm.$refs.jwt_access_modal.show_modal(data.uuid);
        };
        let onCreatedRow = (/* a */) => {
          // console.log(a)
        };
        let requestTransform = (data) => {
          data.search.access_uuid = vm.uuid;
        };
        vm.datatable = init_ajax_data_datables(
          vm,
          vm.$refs.table,
          window.jQuery.fn.api.settings.api[
            "api manager dynamic jwt token url"
          ],
          columns,
          onSelect,
          onCreatedRow,
          requestTransform,
        );
      }
    },
  },
  mounted() {
    // this.init_table();
  },
  watch: {},
  updated: function() {},
};
</script>
